export function getPermissionsLiterals(t: any) {
    return {
        title: t("permissons.title"),
        description: t("permissons.description"),
        savebutton:t("permissons.savebutton"),
    };
}



export function getChecksLiterals(t: any, data: IChecks) {
    return {
        checks: [
            {
                id: "comercial-communications",
                template: t(
                    "checksRegisterModal.checks.comercial-communications.template"
                ),
                value: data["comercial-communications"],
            },
            {
                id: "personal-data-sharing",
                template: t(
                    "checksRegisterModal.checks.personal-data-sharing.template"
                ),
                value: data["personal-data-sharing"],
            },
            {
                id: "profile-custom-experience",
                template: t(
                    "checksRegisterModal.checks.profile-custom-experience.template"
                ),
                value: data["profile-custom-experience"],
            },
        ],
    };
}


export interface IChecks {

    "comercial-communications": boolean;
    "personal-data-sharing": boolean;
    "profile-custom-experience": boolean;
}


